import { FeedBackMessage } from "@artprov/design-system";
import PropTypes from "prop-types";

/**
 * Componente que muestra un mensaje de estado vacío o error
 * @param {node} icon - Icono a mostrar
 * @param {string} iconStyles - Estilos CSS para el icono
 * @param {node} title - Título del mensaje
 * @param {string} titleStyles - Estilos CSS para el título
 * @param {node} description - Descripción del mensaje
 * @param {string} descriptionStyles - Estilos CSS para la descripción
 * @returns {JSX.Element} Componente EmptyStateMessage
 */
const EmptyStateMessage = ({ 
  icon = "error", 
  iconStyles = "text-warning-10", 
  title = "No hay resultados para mostrar", 
  titleStyles = "text-primary-10 text-lg", 
  description = "La búsqueda no coincide con ningún registro existente. Por favor, verificá los datos.", 
  descriptionStyles = "text-sm" 
}) => (
  <div className="w-full flex items-center justify-center flex-col mt-11">
    <div className="flex w-80 items-center">
      <FeedBackMessage
        {...(icon && { icon })}
        {...(iconStyles && { iconStyles })}
        {...(title && { title })}
        {...(titleStyles && { titleStyles })}
        {...(description && { description })}
        {...(descriptionStyles && { descriptionStyles })}
      />
    </div>
  </div>
);

EmptyStateMessage.propTypes = {
  icon: PropTypes.node,
  iconStyles: PropTypes.string,
  title: PropTypes.node,
  titleStyles: PropTypes.string,
  description: PropTypes.node,
  descriptionStyles: PropTypes.string,
}

export default EmptyStateMessage;